import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { TextField } from '../fields';
import { FormattedMessage } from 'react-intl';
import messages from '../../text/messages';

import './searchBar.css';

class SearchBar extends React.Component {
    render() {
        const { handleSubmit, onSubmit, reset, live, value } = this.props;

        let rest = live ? { onChange: e => onSubmit({ value: e.target.value }) } : {};

        return (
            <div className="search-bar">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-xs-12">
                            <Field name="value" component={TextField} placeholder={messages.search} {...rest} />
                        </div>
                        {value &&
                            value !== '' && (
                                <div
                                    className="reset-button"
                                    onClick={() => {
                                        reset();
                                        onSubmit({ value: '' });
                                    }}
                                >
                                    <FormattedMessage {...messages.reset} />
                                </div>
                            )}
                    </div>
                </form>
            </div>
        );
    }
}

SearchBar.defaultProps = {
    onSubmit: undefined,
    live: true
};
SearchBar.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    live: PropTypes.bool
};

SearchBar = connect(state => {
    const selector = formValueSelector('search-bar-form');
    return {
        value: selector(state, 'value')
    };
})(SearchBar);

SearchBar = reduxForm({
    form: 'search-bar-form',
    destroyOnUnmount: true,
    enableReinitialize: false,
    forceUnregisterOnUnmount: true,
    keepDirtyOnReinitialize: false
})(SearchBar);

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/searchBar/index.jsx